/** @format */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'htmlEntitiesDecode',
})
export class HtmlEntitiesDecodePipe implements PipeTransform {
  readonly type: DOMParserSupportedType = 'text/html';

  transform(value: string | null | undefined): string {
    if (!value || typeof value !== 'string') {
      return '';
    }

    const parser = new DOMParser();
    const decodedString = parser.parseFromString(value, this.type).documentElement.textContent;

    return decodedString || '';
  }
}
